var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isEmpty(_vm.selectedTrips) ? _vm._l(_vm.selectedTrips, function (trip, indexTrips) {
    return _c('div', {
      key: indexTrips,
      staticClass: "mb-25 pl-50 border-secondary rounded-lg hover-bg-light-warning"
    }, [_c('b-form-checkbox', {
      staticClass: "custom_checkbox_selectedTrip",
      model: {
        value: trip.isChecked,
        callback: function callback($$v) {
          _vm.$set(trip, "isChecked", $$v);
        },
        expression: "trip.isChecked"
      }
    }, [_c('div', {
      staticClass: "d-flex-between"
    }, [_c('div', {
      staticClass: "fw-700"
    }, [_vm._v(" " + _vm._s(indexTrips + 1) + " ")]), _c('div', {
      staticClass: "d-flex flex-column mx-25"
    }, _vm._l(trip.segments, function (segment, indexSegment) {
      var _segment$bookingClass, _segment$bookingClass2, _segment$bookingClass3, _segment$bookingClass4, _segment$bookingClass5;
      return _c('div', {
        key: indexSegment,
        class: "fw-700 d-flex flex-wrap gap-1 ".concat(!['lg', 'xl'].includes(_vm.appBreakPoint) ? 'font-small-4' : 'font-medium-1', " ")
      }, [_c('span', [_vm._v(_vm._s("".concat(segment.airline).concat(segment.flightNumber)))]), _c('span', {
        class: segment.bookingClass.changed ? 'text-danger' : ''
      }, [_vm._v(_vm._s(segment.bookingClass.code))]), _c('span', [_vm._v(_vm._s(_vm.convertISODateTime(segment.departureDate, segment.departureTimezone).dayMonth))]), _c('span', [_vm._v(_vm._s("".concat(segment.departure).concat(segment.arrival)))]), _c('span', [_vm._v(_vm._s(['LL'].includes(segment === null || segment === void 0 ? void 0 : (_segment$bookingClass = segment.bookingClass) === null || _segment$bookingClass === void 0 ? void 0 : _segment$bookingClass.status) ? 'HL' : ['NN'].includes(segment === null || segment === void 0 ? void 0 : (_segment$bookingClass2 = segment.bookingClass) === null || _segment$bookingClass2 === void 0 ? void 0 : _segment$bookingClass2.status) ? "".concat(segment === null || segment === void 0 ? void 0 : (_segment$bookingClass3 = segment.bookingClass) === null || _segment$bookingClass3 === void 0 ? void 0 : _segment$bookingClass3.status).concat(segment === null || segment === void 0 ? void 0 : (_segment$bookingClass4 = segment.bookingClass) === null || _segment$bookingClass4 === void 0 ? void 0 : _segment$bookingClass4.availability) : (segment === null || segment === void 0 ? void 0 : (_segment$bookingClass5 = segment.bookingClass) === null || _segment$bookingClass5 === void 0 ? void 0 : _segment$bookingClass5.status) || ''))]), _c('span', [_vm._v(_vm._s("".concat(_vm.convertISODateTime(segment === null || segment === void 0 ? void 0 : segment.departureDate, segment === null || segment === void 0 ? void 0 : segment.departureTimezone).hourMin, " ").concat(_vm.convertISODateTime(segment === null || segment === void 0 ? void 0 : segment.arrivalDate, segment === null || segment === void 0 ? void 0 : segment.arrivalTimezone).hourMin)))]), _c('span', [_vm._v(_vm._s(segment.airCraft))])]);
    }), 0), _c('div', [_c('b-button', {
      staticClass: "p-50",
      attrs: {
        "variant": "flat-danger"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.deleteTripHandle(trip.selectedTripId);
        }
      }
    }, [_c('feather-icon', {
      staticClass: "cursor-pointer",
      attrs: {
        "icon": "XIcon",
        "size": "18"
      }
    })], 1)], 1)])])], 1);
  }) : _c('div', {
    staticClass: "text-warning font-italic mx-1"
  }, [_vm._v(" Chưa chọn chuyến bay ")])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }